<template>
    <div class="login" v-show="wxshow">
        <div class="login-topbar clear">
            <!-- <div class="left" @click="goback"><i class="iconfont">&#xef57;</i>返回</div> -->
            <!-- <div class="right fs2 c9" @click="logout">密码登录</div> -->
        </div>
        <div class="tac login-header">
            <h2 v-if="pagetype == 'password'">密码登录</h2>
            <h2 v-if="pagetype == 'nopassword'">登陆体验更多功能</h2>
            <h2 v-if="pagetype == 'reset'">重置密码</h2>
        </div>
        <van-cell-group class="login-form">
            <van-field
                v-model="username"
                type="tel"
                placeholder="输入手机号"
                clearable
                @keyup="isPhone() ? smsDisabled = false : smsDisabled = true"
                class="login-form__field"
                />
            <van-field
                v-if="pagetype == 'password' || pagetype == 'reset'"
                v-model="password"
                type="password"
                placeholder="输入密码"
                clearable
                class="login-form__field"
                />
            <van-field
                v-if="pagetype == 'reset'"
                v-model="repeatPassword"
                type="password"
                placeholder="重复输入密码"
                clearable
                class="login-form__field"
                />
            <van-field
                v-if="pagetype != 'password'"
                v-model="smscode"
                center
                clearable
                placeholder="输入验证码"
                class="login-form__field"
            >
                <van-button
                    slot="button"
                    size="small"
                    :disabled="smsDisabled"
                    @click="sendSms"
                    type="primary">{{smsText}}</van-button>
            </van-field>
        </van-cell-group>
        <van-button
            v-if="pagetype == 'password' || pagetype == 'nopassword'"
            @click="onSubmit"
            type="primary"
            size="large"
            class="mtw">登录</van-button>
        <van-button
            v-if="pagetype == 'reset'"
            @click="onSubmit"
            type="primary"
            size="large"
            class="mtw">重置密码</van-button>
        <footer class="clear mtm fs2 c9">
            <div class="left fs2 c9" v-if="pagetype == 'password'" @click="pagetype = 'nopassword'">免密码登录</div>
            <div class="left fs2 c9" v-if="pagetype != 'password'" @click="pagetype = 'password'">密码登录</div>
            <div class="right"
                v-if="pagetype != 'reset'"
                @click="pagetype = 'reset'"
                >找回密码</div>
            <div class="right fs2 c9" v-if="pagetype == 'reset'" @click="pagetype = 'nopassword'">免密码登录</div>
        </footer>
        <van-row type="flex" justify="center" class="mtw pbw">
            <van-col span="6" class="tac"><i @click="onwxlogin" class="login-social__wechat iconfont">&#xe6b4;</i></van-col>
        </van-row>
    </div>
</template>
<script>
import Vue from "vue";
import { Field,Button,Toast } from 'vant';
import wechatService from '@/assets/scripts/wechat';
import axios from "@/assets/scripts/api";

Vue.use(Field).use(Button).use(Toast);
export default {
    name: 'Login',
    data(){
        return {
            pagetype: 'password', // 页面类型 password:密码登录 nopassword:免密码登陆 reset:找回密码
            username: '',   // 用户名
            password: '',   // 密码
            repeatPassword: '', // 重复输入密码
            smscode: '',    // 短信验证码
            smsText: '发送验证码', // 发送验证码文案
            smsDisabled: true,     // 发送验证码状态
            submitText: '登录',
            redirect: '/venue/#/my',  // 登录后回调页面
            wxshow: true,   //默认显示
        }
    },
    created(){
        let params = this.$route.query;
        if (params.redirect=='/venue/my') {
            params.redirect = ''
        }
        this.redirect = params.redirect || '/venue/#/my'
        this.wxshow=false   //微信授权的时候隐藏dom
        Toast('登录验证中')
        let wechatState = params.state;
        let wechatCode = params.code;
        let $this = this;
        if(wechatState == 'wechat' && wechatCode){
          // 微信登录回调时
            axios.post('login/loginSocial',{
                type: 'weixin',
                code: wechatCode
            }).then(res => {
                if(res.data.code == 0){
                    location.replace($this.redirect);
                }else{
                    Toast(res.data.message);
                }
            });
        }else{
            Toast.clear()
            this.wxshow=true
        }
    },
    methods: {
        sendSms:function(){
            // 发送验证码
            let $this = this;
            this.smsText = '正在获取';
            this.smsDisabled = true;
            let data = {
                mobile: this.username,
                sms_type: 'system_remind'
            };

            if('reset' == this.pagetype){
                data.sms_type = 'sms_forget_password'
            }

            this.$http.post('sms/send',data).then(function(res){
                if(0 == res.data.code){
                    // success
                    $this.countDown()
                }else{
                    // error
                    Toast(res.data.message)
                    $this.sendInit()
                }
            });
        },
        sendInit: function(){
            // 初始化 发送验证码状态
            this.smsText = '发送验证码';
            this.smsDisabled = false;
        },
        countDown: function(){
            // 倒计时
            let timeout = 60;
            let timer = setInterval(() => {
                if (timeout <= 0) {
                    clearInterval(timer);
                    this.sendInit();
                    return;
                }
                this.smsText = timeout + ' s';
                timeout--;
            }, 1000);
        },
        goback: function(){
          // 返回
          window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        onSubmit:function(){
            // 表单处理
            if(!this.isPhone()){
                Toast.fail('请输入正确的手机号');
                return;
            }

            if('nopassword' != this.pagetype){
                if(!this.password){
                    Toast.fail('请输入密码');
                    return;
                }
            }

            if('reset' == this.pagetype){
                if(this.password != this.repeatPassword){
                    Toast.fail('重复密码不一致');
                    return;
                }
            }

            if('password' != this.pagetype){
                if(!this.smscode){
                    Toast.fail('请输入短信验证码');
                    return;
                }
            }
            // 登陆操作
            let $this = this;
            this.$http.post('login/login_check',{
                _username: this.username,
                _password: this.password,
                sms_code: this.smscode
            }).then(function(res){
                if(res.data.code == 0){
                    // success
                    if('reset' == $this.pagetype){
                        $this.resetSubmit();
                    }else{
                        Toast.success('登录成功！')
                        location.replace($this.redirect);
                    }
                }else{
                    // error
                    if(res.data.code == 404){
                        $this.pagetype = 'nopassword';
                        $this.sendSms();
                    }else{
                        Toast(res.data.message)
                    }

                }
            })
        },
        resetSubmit: function(){
          // 重置密码
            this.$http.post('user/setupPassword',{
                password: this.repeatPassword
            }).then(res => {
                if(res.data.code == 0){
                    Vue.cookie.delete('_ibl');
                    Toast.success('请用新密码登陆')
                    this.pagetype = 'password';
                }else{
                    // error
                    Toast(res.data.message);
                }
            })
        },
        isPhone: function(){
            // 用户名是否是合法手机号
            let re = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
            return re.test(this.username);
        },
        getAuthorizeURL: function(){
          // 微信登录
            location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx65e371fb9ae91702&redirect_uri=https%3A%2F%2Fwww.buole.com%2Fvenue%2Flogin&response_type=code&scope=snsapi_userinfo&state=wechat&connect_redirect=1#wechat_redirect";
            // location.href = "https://open.weixin.qq.com/connect/qrconnect?appid=wx65e371fb9ae91702&redirect_uri=https%3A%2F%2Fwww.buole.com%2Fvenue%2Flogin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
        },
        onwxlogin() {
            wechatService.wxOAuthUrl(encodeURIComponent(location.href),'wechat')
        },
    }
}
</script>
<style lang="less">
.login{
    padding: .3rem;
    &-header{
        text-align: center;
        &>h2{
            margin: 0;
            font-weight: 400;
            font-size: .22rem;
            padding: 40px 15px 15px;
        }
    }
    &-form{
        margin-top: .2rem;
        &__field{
            position: relative;
            font-size: .16rem;
            &:after{
                left: 0 !important; bottom: 0;
                height: .02rem;
                border-bottom-width: 0 !important;
                background-color: #f6f6f6;
            }

        }
    }
    &-social__wechat.iconfont{
        width: .4rem; height: .4rem;
        line-height: .4rem;
        border-radius: 50%;
        text-align: center;
        font-size: .26rem;
        padding: .1rem;
        color: white;
        background-color: #68c864;
    }
    .van-hairline--top-bottom::after{
        border-width: 0 0;
    }
    .van-button--large{
        height: .4rem; line-height:.38rem;
    }
    .van-field__control{
        height: .32rem;
        line-height: unset;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue